export const PRODUCT_ENDPOINTS = {
    LIST: "/InfluencersProduct/GetProductListSimple",
    CATEGORIES: "/InfluencersProduct/GetCategoriesSimple",
    DEFAULT_IMAGE: "/User/GetDefaultImage",
};
